<template>
  <v-container>
    <div id="grid-relator">
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Evaluación de relatores</v-toolbar-title
        >
      </v-toolbar>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :rows-per-page-items="rowsTable"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.rut + "-" + props.item.dv }}</td>
              <td class="text-xs-left">{{ props.item.capacitacion }}</td>
              <td class="text-xs-left">Activo</td>
              <td class="text-xs-left">
                {{
                  props.item.evaluacion == null
                    ? "Sin evaluar aún"
                    : props.item.evaluacion
                }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.fechaEvaluacion == null
                    ? "Sin evaluar aún"
                    : props.item.fechaEvaluacion
                }}
              </td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver Evaluacion"
                  @click="viewEvaluacion(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR'
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar Relator"
                  @click="editEvaluacion(props.item.id)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >Consultar Evaluación
            <v-flex v-if="usuarioLoggedTipe == 'PROVEEDOR'">
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>open_in_new</v-icon> </v-btn
              >Editar Evaluación
            </v-flex>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-flex>
        <v-btn color="primary" @click="descargaMasiva()">Descarga masiva</v-btn>
      </v-flex>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-relator-evaluacion",

  components: {
    Loading,
    LoadingDescarga,
    AlertEmpty,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      dialogLoading: false,
      usuarioLoggedTipe: "",
      desactivarUpload: false,
      loading: false,
      dialog: false,
      alerta: false,
      id: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        { text: "Rut Relator", align: "left", sortable: false, value: "rut" },
        {
          text: "Tipo Relatoría",
          sortable: false,
          value: "tipoRelatoría",
        },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Evaluación", sortable: false, value: "evaluacion" },
        { text: "Fecha Evaluación", sortable: false, value: "fechaEvaluacion" },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
      bloqueo: Boolean,
      itemsDocumento: [],
      proceso: "",
      tipeArchive: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.loadData();
  },

  mounted() {},
  computed: {},
  methods: {
    async loadRelatoresFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
      };
      return await axios
        .post("/evaluacionRelatores", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadRelatoresFilter();
      if (this.itemsDocumento.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        rcInhabilitado: this.rc_inhabilitadoValue,
        apto: this.aptoValue,
        tipoCapacitacion: this.tipo_capValue,
      };
      axios
        .post("evaluacionRelator/downloadExcel", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_RELATORES.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editEvaluacion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "EvaluacionRelatorRegistra",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
    viewEvaluacion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "EvaluacionRelatorRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
